<template>
  <div class="test-question-filter-by-product-code">
    <i-tree :data="data" expand-node />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TestQuestionFilterByProductCode',
  props: {
    filterMenu: { type: Object, required: true },
  },
  data() {
    return {
      data: [
        {
          title: '年份',
          expand: true,
          children: [],
        },
        {
          title: '难易度',
          expand: true,
          children: [],
        },
        {
          title: '产品组',
          expand: true,
          children: [],
        },
      ],
      yearsFilter: [],
      levelsFilter: [],
      groupCodesFilter: [],
    };
  },
  watch: {
    filterMenu(menu) {
      this.settingTreeData(menu);
    },
    yearsFilter(values) {
      this.setAddBigQuestionRuleOfYears({ years: values });
    },
    levelsFilter(values) {
      this.setAddBigQuestionRuleOfLevels({ levels: values });
    },
    groupCodesFilter(values) {
      this.setAddBigQuestionRuleOfProductGroupCodes({ productGroupCodes: values });
    },
  },
  methods: {
    ...mapActions({
      setAddBigQuestionRuleOfYears: 'createPaperStore/invokeSetAddBigQuestionRuleOfYears',
      setAddBigQuestionRuleOfLevels: 'createPaperStore/invokeSetAddBigQuestionRuleOfLevels',
      setAddBigQuestionRuleOfProductGroupCodes: 'createPaperStore/invokeSetAddBigQuestionRuleOfProductGroupCodes',
    }),
    /**
     * 设置目录树data
     */
    settingTreeData({ years, levels, groupCodes }) {
      const yearsChildren = [];
      const levelsChildren = [];
      const groupCodesChildren = [];

      // 年份
      yearsChildren.push({
        expand: false,
        type: 'year',
        render: (h) => {
          const yearsCheckbox = [];

          years.forEach((year) => {
            yearsCheckbox.push(h('i-checkbox', {
              props: {
                label: year,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.yearsFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'year' }),
            },
          }, yearsCheckbox)]);
        },
      });

      // 困难度
      levelsChildren.push({
        expand: false,
        type: 'level',
        render: (h) => {
          const levelsCheckbox = [];

          levels.forEach((level) => {
            levelsCheckbox.push(h('i-checkbox', {
              props: {
                label: level,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.levelsFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'level' }),
            },
          }, levelsCheckbox)]);
        },
      });

      // 产品组
      groupCodesChildren.push({
        expand: false,
        type: 'level',
        render: (h) => {
          const groupCodesCheckbox = [];

          groupCodes.forEach((groupCode) => {
            groupCodesCheckbox.push(h('i-checkbox', {
              props: {
                label: groupCode,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.groupCodesFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'groupCode' }),
            },
          }, groupCodesCheckbox)]);
        },
      });

      this.data[0].children = yearsChildren;
      this.data[1].children = levelsChildren;
      this.data[2].children = groupCodesChildren;
    },
    /**
     * 选择筛选条件复选框数据绑定
     */
    selectFiltersCheckbox({ type }) {
      return (values) => {
        if (type === 'year') {
          this.yearsFilter = values;
        } else if (type === 'level') {
          this.levelsFilter = values;
        } else if (type === 'groupCode') {
          this.groupCodesFilter = values;
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>
.test-question-filter-by-product-code {
  width: 50%;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;

  /deep/ .ivu-tree {
    .ivu-tree-title:hover,
    .ivu-tree-title-selected,
    .ivu-tree-title-selected:hover {
      background-color: transparent;
    }

    .ivu-tree-children .ivu-tree-arrow {
      width: 0;
    }

    > .ivu-tree-children > li > .ivu-tree-arrow {
      width: 12px;
    }

    .ivu-checkbox-group {
      display: flex;
      flex-direction: column;

      > .ivu-checkbox-group-item {
        margin-bottom: 6px;

        &:last-of-type {
          margin-bottom: 0;
        }

        > span:last-of-type {
          margin-left: 6px;
        }
      }

      > .ivu-select {
        margin-bottom: 6px;
      }
    }
  }

  /deep/ .ivu-select-dropdown {
    padding: 0;

    .ivu-select-dropdown-list {
      padding: 4px 8px;

      .ivu-select-item {
        margin: 0;
        padding: 3px 0;
        font-size: 13px !important;
      }

      .ivu-select-item-focus,
      .ivu-select-item-selected:hover {
        background-color: transparent;
      }

      .ivu-select-item-selected::after {
        font-size: 16px;
      }
    }
  }

  /deep/ .exclusive-model {
    width: 280px;

    > .ivu-select-selection > div {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
